<template>
<div id="login-container" class="container">
    <h1 class="form-title" style="color: #ffff">RAFIKI<span style="font-weight:100">LITE</span></h1>
    <div class="row center-xs">
        <div class="col-xs-12 col-sm-3">
            <form name="loginForm">
                <div class="form__wrapper">
                    <input class="form__input" id="email" type="email" v-model="email" required autofocus>
                    <label class="form__label" for="email">
                        <span class="form__label-content">
                            E-mail
                        </span>
                    </label>
                </div>
                <div class="form__wrapper">                    
                    <div>
                        <input class="form__input" id="password" type="password" v-model="password" required>
                        <label class="form__label" for="password">
                            <span class="form__label-content">
                                Password
                            </span>
                        </label>
                    </div>
                </div>

                <div class="form-error" v-if="loginError">
                  <alert-circle-icon class="text-danger" :size="36"></alert-circle-icon> Invalid e-mail or password.
                </div>

                <div class="form__wrapper--submit">
                    <div class="form_input--submit">
                        <button name="submit" class="btn btn-block" type="submit" @click="handleSubmit">
                            Login
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import { UserService, LoggingService } from '@/services/ApiService';
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';

export default {
    name: 'Login',
    components: {
        AlertCircleIcon
    },
    data(){
        return {
            email : "",
            password : "",
            loginError: false
        }
    },
    created: function () {
        const root = document.documentElement;
        root.style.setProperty('--body-bg', '#00BCD4');
    },
    methods: {
        handleSubmit(e){
            e.preventDefault()
            if (this.password.length > 0) {
                UserService.login(this.email, this.password).then(response => {

                    localStorage.setItem('user', JSON.stringify(response.data.user))
                    localStorage.setItem('jwt', response.data.token)

                    if (localStorage.getItem('jwt') != null){
                        this.$router.push('/admin'); 
                    }                 
                }).catch(err => {
                    this.loginError = true;
                    LoggingService.log("Login", "Error logging in", err);
                });
            }
        },
    }
}
</script>

<style lang="less">

</style>